import ApiModule from '../api-module';
import camelCase from 'lodash/camelCase';

class Resource extends ApiModule {
  public name;
  public path;
  public endpoint;
  public body;
  public appendedUrl;

  constructor({ endpoint, path, name, query = {}, payloadPath }) {
    super({ name, payloadPath, query });
    this.name = name ? name : camelCase(path.replace('/', ''));
    this.path = path;
    this.endpoint = endpoint;
    this.body = {};
    this.appendedUrl = '';
  }

  setEndpoint = (endpoint) => {
    this.endpoint = endpoint;
    return this;
  };
}

export default Resource;
